import '../scss/app.scss';

const setConsultation = () => {
    const triggers = document.getElementsByClassName('request-consult');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];    
            trigger.addEventListener('click', function(e){
                e.preventDefault();
                window.RDG.Modal.create('request-consult', 'Schedule a Complimentary Portfolio Review', '/contact-us/', 'modal-lg');
            });
        }
    }
}

const setScheduleReviewHero = () => {
    const triggers = document.querySelectorAll('.schedule-call-modal');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];    
            let target = <HTMLAnchorElement>triggers[i].querySelector('a');
            trigger.addEventListener('click', function(e){
                e.preventDefault();
                const link = this.href;
                window.RDG.Modal.create('schedule-call', 'Schedule a Complimentary Portfolio Review', link, 'modal-lg');
            });
        }
    }
}

const setNewsletterSignup = () => {
    const triggers = document.querySelectorAll('.newsletter-modal');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];    
            let target = <HTMLAnchorElement>triggers[i].querySelector('a');
            trigger.addEventListener('click', function(e){
                e.preventDefault();
                const link = this.href;
                window.RDG.Modal.create('newsletter-signup', 'Sign Up for The Wire', link, 'modal-lg');
            });
        }
    }
}

const setNewsletterSignupSub = () => {
    const triggers = document.querySelectorAll('.schedule-review-sibg .icon-block');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];    
            let target = <HTMLAnchorElement>triggers[i].closest('.icon-text-set').querySelector('a');
            trigger.addEventListener('click', function(e){
                target.click();
            });
        }
    }
}

const setScheduleReviewSub = () => {
    const triggers = document.querySelectorAll('.schedule-review-sub .icon-block');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];    
            let target = <HTMLAnchorElement>triggers[i].closest('.icon-text-set').querySelector('a');
            trigger.addEventListener('click', function(e){
                target.click();
            });
        }
    }
}

const getNews = (cat_id, type_id, pg:number=0) => {
    // @ts-ignore
    const ajaxUrl = wp.ajaxurl;
    // @ts-ignore
    const nonce = wp.nonce;

    return jQuery.ajax({
        url: ajaxUrl,
        type: 'GET',
        data : {
            action: "newsList", 
            cat_id : cat_id, 
            type_id : type_id, 
            pg : pg,
            nonce: nonce
        }
    });
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const prevNextPost = ($) => {
    $(document).on('click', '.pods-pagination-simple a', function(e) {
        e.preventDefault();
        $('html').scrollTop(0);
        const page = parseInt(getParameterByName('pg', $(this).attr('href')));
        const type_id = (document.getElementById('news_types') as HTMLSelectElement).value;
        const cat_id = (document.getElementById('news_categories') as HTMLSelectElement).value;
        getNews(cat_id, type_id, page).done(function (result) {
            const newsListing = document.getElementById('news-listing');
            newsListing.innerHTML = result;
        });
    });
}


const newsCategorySelect = ($) => {
    $(document).on('change', '.filter-select', function() {
        const type_id = (document.getElementById('news_types') as HTMLSelectElement).value;
        const cat_id = (document.getElementById('news_categories') as HTMLSelectElement).value;

        getNews(cat_id, type_id).done(function (result) {
            const newsListing = document.getElementById('news-listing');
            newsListing.innerHTML = result;
        });
    });
}

(function($) {
    $(document).on('gform_confirmation_loaded', function(event, formId){
        window.setTimeout(function() {
            window.RDG.Modal.resizeParentIframe();
        }, 1000);
    });
}(jQuery));

prevNextPost(jQuery);
newsCategorySelect(jQuery);
setConsultation();
setScheduleReviewHero();
setScheduleReviewSub();

setNewsletterSignup();
setNewsletterSignupSub();